
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.363 0H2.637C1.183 0 0 1.242 0 2.77v18.46C0 22.759 1.183 24 2.637 24h24.726C28.817 24 30 22.758 30 21.23V2.77C30 1.241 28.817 0 27.363 0zm.88 21.23c0 .51-.395.924-.88.924H2.637c-.485 0-.88-.414-.88-.923V2.769c0-.509.395-.923.88-.923h24.726c.485 0 .88.414.88.923v18.462z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.286 6.749H4.714c-.394 0-.714.336-.714.75v9.002c0 .415.32.75.714.75h8.572c.394 0 .714-.335.714-.75V7.5c0-.414-.32-.75-.714-.75zm-.715 1.5v7.084H5.428V8.249h7.143zM25.608 7.323h-7.149c-.485 0-.878.414-.878.923 0 .51.393.923.878.923h7.149c.485 0 .879-.413.879-.923s-.394-.923-.88-.923zM25.608 11.016h-7.149c-.485 0-.878.413-.878.923s.393.923.878.923h7.149c.485 0 .879-.414.879-.923 0-.51-.394-.923-.88-.923zM25.608 14.708h-7.149c-.485 0-.878.413-.878.923s.393.923.878.923h7.149c.485 0 .879-.413.879-.923s-.394-.923-.88-.923z","fill":"currentColor"}})])
          )
        }
      }
    